import { EquipmentType, NozzleDirection, NozzleType } from "@/types/common"

const nozzleTypeTexts = {
  [NozzleType.FlowNozzle]: 'Flow Nozzle',
  [NozzleType.EnergyFlowNozzle]: 'Energy Flow Nozzle',
  [NozzleType.InstNozzle]: 'Inst Nozzle',
  [NozzleType.SetNozzle]: 'Set Nozzle',
}
export const nozzleTypeToText = (type: NozzleType) => {
  return nozzleTypeTexts[type] || '-'
}

export const getNozzleTypes = () => {
  return Object.keys(nozzleTypeTexts).map(key => {
    return { value: Number(key), label: nozzleTypeTexts[key]}
  })
}


export const toNozzleDirectionText = (direction: NozzleDirection) => {
  return direction === NozzleDirection.Inlet ? 'Inlet' : 'Outlet'
}

export const getNozzleDirectionOptions = () => {
  return [
    {value: NozzleDirection.Inlet, label: 'Inlet'},
    { value: NozzleDirection.Outlet, label: 'Outlet' },
  ]
}

const equipmentTypeTexts = {
  [EquipmentType.BatteryLimit]: 'Battery Limit',
  [EquipmentType.Stream]: 'Stream',
  [EquipmentType.EnergyStream]: 'Energy Stream',
  [EquipmentType.Vessel]: 'Vessel',
  [EquipmentType.StreamMixer]: 'Stream Mixer',
  [EquipmentType.StreamSplitter]: 'Stream Splitter',
  [EquipmentType.Pump]: 'Pump',
  [EquipmentType.Compressor]: 'Compressor',
  [EquipmentType.Reactor]: 'Reactor',
  [EquipmentType.Expander]: 'Expander',
  [EquipmentType.Spreadsheet]: 'Spreadsheet',
  [EquipmentType.ComponentSplitter]: 'Component Splitter',
  [EquipmentType.HeatExchanger]: 'Heat Exchanger',
  [EquipmentType.Set]: 'Set',
  [EquipmentType.Valves]: 'Valves',
  [EquipmentType.Rotating]: 'Rotating',
  [EquipmentType.Tanks]: 'Tanks',
  [EquipmentType.Deaerator]: 'Deaerator',
  [EquipmentType.SteamDrum]: 'Steam Drum',
  [EquipmentType.Burner]: 'Burner',
}

export const equipmentTypeToText = (type: EquipmentType) => {
  return equipmentTypeTexts[type] || '-'
}

export const getEquipmentOptions = () => {
  return Object.keys(equipmentTypeTexts).map(key => {
    return { value: Number(key), label: equipmentTypeTexts[key] }
  })
}
